module.exports = __webpack_public_path__ + "img/thumb_18.ce1884cb.jpg";